import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { SavingsCalculator } from "./components/SavingsCalculator";
import { About } from "./components/about";
import { Services } from "./components/services";
import { HowItWorks } from "./components/HowItWorks";
import { Gallery } from "./components/gallery";
import { Partners } from "./components/Partners";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Offices } from "./components/Offices";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <WhyChooseUs data={landingPageData.WhyChooseUs} />
      <About data={landingPageData.About} />
      <SavingsCalculator data={landingPageData.SavingsCalculator} />
      <Services data={landingPageData.Services} />
      <HowItWorks data={landingPageData.HowItWorks} />
      {landingPageData.showGallery !== false && <Gallery data={landingPageData.Gallery} />}
      <Partners data={landingPageData.Partners} />
      <Testimonials data={landingPageData.Testimonials} offices={landingPageData.Offices} />
      <Team data={landingPageData.Leadership} />
      <Offices data={landingPageData.Offices} />
      <Contact data={landingPageData.Contact} />

      {/* Sticky CTA */}
      <a href="#contact" className="sticky-cta page-scroll">
        <i className="fa fa-sun-o"></i> Get Free Quote
      </a>
    </div>
  );
};

export default App;
